import {h, Fragment} from "preact"
import ProductSearchCard from "./ProductSearchCard"
import KeywordsBlock from "./KeywordsBlock";
import { settings } from "../config"
import { useEffect, useRef } from "preact/hooks"; 

export default function SearchResultsPanel({
    products, 
    keywords, 
    searchQuery, 
    total,
    loading,
}) {
    const refContainer = useRef(null);
    const popularSearchesKeywords = settings?.popular_searches_terms
        ?.split('\n')
        .filter(Boolean)
        .map(term => ({keyword: term})) || [];

    useEffect(() => {       
        const parent = refContainer.current?.parentNode;
        if (refContainer.current && parent) {
            parent.classList.add("always-display");
        }
    }, []);

    return (
        <div
            ref={refContainer}
            class="ns-autocomplete ns-d-flex ns-flex-column ns-flex-sm-row ns-align-items-start ns-border-box ns-mx-auto"
            data-nosto-element="autocomplete"
        >
            <div class="ns-w-100">
                <div class="ns-autocomplete-container">
                    <KeywordsBlock keywords={keywords} popularKeywords={popularSearchesKeywords} />
                    {products?.length > 0 || loading ? (
                        <div class="ns-autocomplete-products ns-d-flex ns-flex-column ns-flex-grow-1">
                            <div class="quick_search_intial_flex">
                                <h4 class="ss__autocomplete__title ss__autocomplete__title--content quick_search_initial_title font-secondary mono-xsm" aria-level="3" role="heading">Product Suggestions</h4>
                                {searchQuery && total ? (
                                    <a href={`/search?q=${searchQuery}`} class="font-primary body-md search__result_text">
                                        <span class="search__result_text_span">{`See ${total} results for "${searchQuery}"`}</span>
                                        <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path id="Rectangle 1134257741" d="M6.07191 0.685425L10.8335 5.18543M10.8335 5.18543L6.07192 9.68542M10.8335 5.18543L0.833496 5.18543" stroke="#FDFCF9" stroke-width="1.25"></path></svg>
                                    </a>
                                ) : null}
                            </div>
                            <div class="quick_search_default_products">
                                {products?.map(mappedProduct => (
                                    <ProductSearchCard product={mappedProduct} />
                                ))}
                            </div>
                        </div>
                    ) : (
                        <div class="ns-autocomplete__no-results ns-flex-grow-1">
                            <span>{`No results found for "${searchQuery}". `}</span>
                            <span>Please try another search.</span>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
